// extracted by mini-css-extract-plugin
module.exports = {"bms_sidebar":"ProjectStatusesSideBar_bms_sidebar__2i3MB","bms_button":"ProjectStatusesSideBar_bms_button__9-t1Z"};